<template>
    <div class="blog_info_wrps">
        <div class="blog_info_heading_wrps">
            <div class="row align-items-center">
                <div class="col-auto ml-auto">
                    <button class="btn btn-primary mr-3" :class="!pubBlogState ? 'actv_blog' : ''"
                        @click="pubBlogState = !pubBlogState">My Blogs</button>
                    <template v-if="userInfo && userInfo.guest">
                        <img src="@/assets/images/edit_profile.png" class="img-fluid create" width="28"
                            title="create blogs">
                    </template>
                    <template v-else>
                        <template v-if="userInfo">
                            <template v-if="!userInfo.profile.area_of_work || !userInfo.profile.bio">
                                <a href="javascript:void(0)" class="create_blog_icon">
                                    <i aria-hidden="true" title="create blog" class="fa fa-pencil-square-o"
                                        @click="userInfoAlertPopupOpenFun"></i>
                                </a>
                            </template>
                            <template v-else>
                                <router-link :to="{ name: 'blogCreate' }" class="create_blog_icon">
                                    <i aria-hidden="true" title="create blog" class="fa fa-pencil-square-o"></i>
                                </router-link>
                            </template>
                        </template>
                    </template>
                </div>
            </div>
        </div>
        <div class="blog_info_body_wrps" v-if="blogListState && publicBlogListState">
            <div class="blog_some_info_wrp" v-for="item in blogListResults" :key="item.id">
                <h2 class="blog_title">
                    <router-link :to="{ name: 'blogDetail', params: { blogId: item.id } }">{{ item.title }}
                    </router-link>
                </h2>
                <div v-html="item.data" class="blog_content"></div>
                <div class="blog_read_more_btn">
                    <router-link :to="{ name: 'blogDetail', params: { blogId: item.id } }">Read More</router-link>
                </div>
                <ul class="blog_action_list" v-if="selfUserId === item.user.id">
                    <li>
                        <router-link :to="{ name: 'blogUpdate', params: { updateId: item.id } }"><i
                                class="fa fa-pencil"></i></router-link>
                    </li>
                    <li v-if="userInfo && userInfo.is_superuser"><i class="fa fa-trash" v-on:click="openRemoveBlogPopup(item.id)"></i>
                    </li>
                </ul>
            </div>
            <template v-if="blogListResults.length === 0 && !pubBlogState">
                <h5 class="no_blog_alert">Sorry, You don't have any blogs</h5>
            </template>
            <template v-if="pubBlogState">
                <div class="blog_some_info_wrp" v-for="item in publicBlogListResults" :key="item.id">
                    <h2 class="blog_title">
                        <router-link :to="{ name: 'blogDetail', params: { blogId: item.id } }">{{ item.title }}
                        </router-link>
                    </h2>
                    <div v-html="item.data" class="blog_content"></div>
                    <div class="blog_read_more_btn">
                        <router-link :to="{ name: 'blogDetail', params: { blogId: item.id } }">Read More
                        </router-link>
                    </div>
                    <ul class="blog_action_list" v-if="userInfo && userInfo.is_superuser">
                        <li v-if="userInfo.is_superuser"><i class="fa fa-trash" @click="openRemoveBlogPopup(item.id)"></i></li>
                    </ul>
                </div>
            </template>
        </div>
        <profile-update-alert-popup v-if="profileUpdateAlertPopup"></profile-update-alert-popup>
    </div>
</template>

<script>
/*eslint-disable */
import { mapGetters } from 'vuex';
import toast from '@/services/toast';
import { bus } from '@/main';
import profileUpdateAlertPopup from '@/components/private/common/profile-update-alert-popup/index.vue';

export default {
    name: 'blog-list',
    components: {
        'profile-update-alert-popup': profileUpdateAlertPopup
    },
    props: ['userInfo'],
    data() {
        return {
            blogListState: null,
            blogListResults: [],
            publicBlogListState: null,
            publicBlogListResults: [],
            blogActv: 'blog',
            blogRemovedPopup: false,
            removeBlogId: '',
            pubBlogState: true,
            selfUserId:'',
            profileUpdateAlertPopup: false,
        }
    },
    computed: {
        ...mapGetters([
            'publicBlogListGetters',
            'blogListGetters',
        ]),
        getBlogListFun() {
            this.blogListState = this.$store.getters.blogListGetters.data
            return
        },
        setInitialBlogStates() {
            if (this.blogListState) {
                this.blogListResults = this.blogListState.results
            }
        },
        getPubBlogListFun() {
            this.publicBlogListState = this.$store.getters.publicBlogListGetters.data
            return
        },
        setInitialPubBlogStates() {
            if (this.publicBlogListState) {
                this.publicBlogListResults = this.publicBlogListState.results
            }
        },
    },
    mounted() {
        if (localStorage.getItem('LoginedUserID')) {
            this.selfUserId = localStorage.getItem('LoginedUserID')
        }
        this.setInitialBlogStates;
        this.getPubBlogListFun;
        this.setInitialPubBlogStates;
        bus.$on('profileUpdateAlertPopupBus', (data) => {
         this.profileUpdateAlertPopup = data;
        });
    },
    methods: {
        userInfoAlertPopupOpenFun() {
            document.body.classList.add('body_right_scroll_remove');
            this.profileUpdateAlertPopup = true;
        },
        getRemoveListAgain() {
            this.$store.dispatch('getBlogListAction').then((res) => {
                this.blogListState = res.data.data
            }).catch((err) => {

            })
            this.$store.dispatch('getPublicBlogListAction').then((res) => {
                this.publicBlogListState = res.data.data
            }).catch((err) => {

            })
        },
        openRemoveBlogPopup(id) {
            document.body.classList.add('body_right_scroll_remove');
            this.blogRemovedPopup = true
            this.removeBlogId = id
        },
        removeModalItemConfirmFun() {
            this.$store.dispatch('removeBlogDetailsAction', {
                id: this.removeBlogId,
            })
                .then((res) => {
                    if (res.status == '200') {
                        toast.success(res.data.msg);
                        $('body').removeClass('body_right_scroll_remove')
                        this.blogRemovedPopup = false
                        this.removeBlogId = ''
                        this.getRemoveListAgain()
                    }
                }).catch((err) => {
                    toast.error(err.data.user_msg);
                })
            return;
        },
        closeRemoveItemModalFun() {
            document.body.classList.remove('body_right_scroll_remove');
            this.blogRemovedPopup = false
            this.removeBlogId = ''
        },
        openRemoveBlogPopup(id) {
            document.body.classList.add('body_right_scroll_remove');
            this.blogRemovedPopup = true
            this.removeBlogId = id
        },
    },
    watch: {
        getBlogListFun() {
            return this.$store.getters.blogListGetters
        },
        setInitialBlogStates() {
            if (this.blogListState) {
                this.blogListResults = this.blogListState.results
            }
        },
        getPubBlogListFun() {
            return this.$store.getters.publicBlogListGetters
        },
        setInitialPubBlogStates() {
            if (this.publicBlogListState) {
                this.publicBlogListResults = this.publicBlogListState.results
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.blog_info_wrps {
    .main_heading {
        color: #ffffff;
        font-size: 20px;
        text-transform: uppercase;
        font-weight: bold;
        margin: 0px;
        line-height: 1;

        .back_btn {
            vertical-align: middle;
        }
    }

    .btn-primary {
        cursor: pointer;
        position: relative;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        outline: none !important;
        background: rgba(255, 255, 255, 0.12) !important;
        color: #ffffff !important;
        border: none;
        border-radius: 3px;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        font-size: 16px;
        padding: 4px 10px;

        &:hover {
            background: #87cefa !important;
            color: #000 !important;
        }

        &.actv_blog {
            background: #87cefa !important;
            color: #000 !important;
        }
    }

    .blog_info_heading_wrps {
        border-bottom: 1px solid rgba(255, 255, 255, 0.05);
        padding: 10px 15px;
    }

    .blog_title {
        font-size: 20px;
        margin-bottom: 15px;
        line-height: 1.3;
        color: #fffcc4;
        font-weight: normal;
        letter-spacing: 1.8px;
        word-spacing: 2px;

        a {
            color: #fffcc4;
            text-decoration: none;
            font-family: 'the_bold_fontbold';

            &:hover {
                color: #87cefa;
            }
        }
    }

    .blog_info_body_wrps {
        padding: 15px;
        height: calc(100dvh - 250px);
        overflow-y: auto;
        font-family: 'georgiaregular';

        &::-webkit-scrollbar {
            width: 8px;
            background: #000000;
        }

        &::-webkit-scrollbar-thumb {
            background-color: #232323;
            border-radius: 10px;
        }
    }

    .blog_read_more_btn a {
        color: #87cefa;
        text-decoration: underline;
        cursor: pointer;
        font-size: 16px;
        line-height: 1;

        &:hover {
            color: #ffd400;
        }
    }

    .blog_some_info_wrp {
        background: rgba(255, 255, 255, 0.1);
        padding: 10px;
        border-radius: 4px;
        margin-bottom: 5px;
        position: relative;

        &:nth-child(2n) {
            background: rgba(158, 182, 3, 0.15);
        }

        &:last-child {
            margin-bottom: 0px;
        }

        .blog_action_list {
            margin: 0;
            position: absolute;
            bottom: 5px;
            right: 10px;
            display: none;

            li {
                margin-left: 15px;

                .fa {
                    font-size: 18px;
                    cursor: pointer;
                    color: #fff;

                    &:hover {
                        color: #ffd400;
                    }
                }
            }
        }

        &:hover .blog_action_list {
            display: flex;
        }
    }

    .blog_read_more_btn {
        padding-top: 10px;
    }

    .no_blog_alert {
        font-size: 18px;
        display: flex;
        height: 100%;
        margin: 0;
        justify-content: center;
        align-items: center;
    }
}

.create_blog_icon {
    display: inline-block;
    vertical-align: middle;

    .fa {
        font-size: 28px;
        color: #ffffff;

        &:hover {
            color: #ffd400;
        }
    }
}
</style>